import {
  ButtonV3,
  GridItem,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import RichText from '@/app/components/RichText';
import { POP_PATHNAME } from '@/app/consts/pathnames';

const MembershipBetterSleep = () => {
  const t = useTranslations();
  const pathname = usePathname();

  return (
    <LayoutGrid data-cy="membership-better-sleep">
      <GridItem
        colStart={{ sm: 'full', lg: 'full' }}
        colEnd={{ sm: 'full', lg: 'full' }}
        className="relative"
      >
        <div className="relative aspect-3200/1111 w-full">
          <ArtDirectionImage
            srcSet={[
              {
                src: 'membership/membership-buy-cta-hero-mobile',
                media: '(max-width: 767px)',
              },
              {
                src: 'membership/membership-buy-cta-hero',
                media: '(min-width: 768px)',
              },
            ]}
            localizedAlt="membership_better_sleep_alt"
            sizes="100vw"
            fill
            className="object-cover"
          />
          <div className="relative mx-6 max-w-[1158px] xl:mx-auto">
            <div className="pt-20 pb-[410px] md:max-w-sm md:py-40 lg:max-w-md lg:py-48 xl:max-w-xl">
              <TypographyV3
                variant="h2"
                Element="h2"
                className="text-4xl text-sandstone-100 md:text-6xl"
                data-cy="better_sleep_banner_title"
              >
                <RichText messageKey="better_sleep_banner_title" />
              </TypographyV3>
              <Link
                href={POP_PATHNAME}
                onClick={async () => {
                  await window.ouraAnalytics.track(EventType.CTAClicked, {
                    cta: 'Buy Oura Ring',
                    location: 'Better Sleep Banner',
                    path: pathname,
                  });
                }}
                passHref
              >
                <ButtonV3
                  variant="primary"
                  className="mt-6"
                  data-cy="better_sleep_banner_cta"
                >
                  {t('better_sleep_banner_cta')}
                </ButtonV3>
              </Link>
            </div>
          </div>
        </div>
      </GridItem>
    </LayoutGrid>
  );
};

export default MembershipBetterSleep;
